export const DEFAULT_SERVICE_TYPE_NAME = [
  { name: 'POS' },
  { name: 'Pickup' },
  { name: 'Delivery' },
  { name: 'Quick Pay' },
  { name: 'Kiosk' },
  { name: 'Self Checkout' },
]

export const TIME_ZONES = [
  { name: '(GMT-10:00) Hawaii', uuid: '1', value: 'Hawaii' },
  { name: '(GMT-09:00) Alaska', uuid: '2', value: 'Alaska' },
  {
    name: '(GMT-08:00) Pacific Time (US & Canada)',
    uuid: '3',
    value: 'Pacific Time (US & Canada)',
  },
  {
    name: '(GMT-07:00) Mountain Time (US & Canada)',
    uuid: '5',
    value: 'Mountain Time (US & Canada)',
  },
  { name: '(GMT-07:00) Arizona', uuid: '9', value: 'Arizona' },
  {
    name: '(GMT-06:00) Central Time (US & Canada)',
    uuid: '10',
    value: 'Central Time (US & Canada)',
  },
  {
    name: '(GMT-05:00) Eastern Time (US & Canada)',
    uuid: '7',
    value: 'Eastern Time (US & Canada)',
  },
  {
    name: '(GMT) UTC',
    uuid: '14',
    value: 'UTC',
  },
]

export const DAY_ABBREVIATIONS = {
  Monday: 'MON',
  Tuesday: 'TUE',
  Wednesday: 'WED',
  Thursday: 'THU',
  Friday: 'FRI',
  Saturday: 'SAT',
  Sunday: 'SUN',
}

export const DAYS_OF_WEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

export const OPENING_HOURS_OPERATING_HOURS = {
  Monday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  Tuesday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  Wednesday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  Thursday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  Friday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  Saturday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
  Sunday: [
    {
      startTime: '',
      endTime: '',
      disabled: true,
      type: 'business_hours',
    },
  ],
}

export const OPENING_HOURS_ORDER_AHEAD_HOURS = {
  Monday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  Tuesday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  Wednesday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  Thursday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  Friday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  Saturday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
  Sunday: {
    startTime: '',
    endTime: '',
    disabled: true,
    type: 'business_hours',
  },
}

export const SEARCH_BAR_ITEMS_OPTIONS = [
  {
    uuid: 'name',
    label: 'Name',
  },
  {
    uuid: 'product_sku',
    label: 'Product SKU',
  },
  {
    uuid: 'price',
    label: 'Price',
  },
  {
    uuid: 'display_name',
    label: 'Display Name',
  },
  {
    uuid: 'uuid',
    label: 'UUID',
  },
]

export const venueSettingsItems = [
  // it will be added in the future

  // {
  //   title: 'Max Order Amount (Dollars)',
  //   description:
  //     'This is the maximum dollar amount an order may have',
  //   type: 'number',
  //   name: 'max_order_amount_in_dollars',
  // },
  {
    title: 'Enable Offline Mode',
    description:
      "By activating this setting, you will switch all Quick Service POS devices to operate in offline mode, ensuring uninterrupted service without internet dependency. Please note, this setting does not impact Full Service POS devices. To reconnect your Quick Service POS devices to online services, you'll need to manually adjust this setting back.",
    type: 'checkbox',
    name: 'force_offline_mode',
    dialogModalText:
      'Are you sure you want to enable Offline Mode for your Quick Service POS devices? This action is immediate and will disable all order syncing within the venue until manually turned off.',
  },
  {
    title: 'Require Manager PIN to Configure POS',
    description:
      'When this setting is enabled, a manager PIN will be required to access the Configuration section of POS.',
    type: 'checkbox',
    name: 'require_manager_for_pos_config',
  },
  {
    title: 'Alcohol Limit Message',
    description:
      'This is the message a customer will see when attempting to place an order that contains alcoholic beverages.',
    type: 'textarea',
    name: 'alcohol_limit_message',
  },
  {
    title: 'Alcohol Limit Per Order',
    description:
      'This is the maximum amount of alcoholic beverages each guest can purchase per order.',
    type: 'number',
    name: 'alcohol_limit_per_order',
  },
  {
    title: 'Require Card Payment to Open Tab',
    description:
      'When enabled, a card payment must be provided before a tab can be opened.',
    type: 'checkbox',
    name: 'require_payment_for_pos_tabs',
  },
  {
    title: 'Allow Cash Payments on POS',
    description:
      'When this setting is enabled, cash will be accepted throughout the venue.',
    type: 'checkbox',
    name: 'allow_cash_payments_on_pos',
  },
  {
    title: 'Allow Ticket Payments on POS',
    description:
      'When this setting is enabled, tickets will be accepted throughout the venue.',
    type: 'checkbox',
    name: 'allow_ticket_payments_on_pos',
  },
  {
    title: 'Allow Gift Card Payments on POS',
    description:
      'When this setting is enabled, gift cards will be accepted throughout the venue.',
    type: 'checkbox',
    name: 'allow_gift_card_payments_on_pos',
  },
  {
    title: 'Confirm Suggested Tip Percentage',
    description:
      'When this setting is enabled, POS devices will ask the guest to confirm the tip suggestion when one has not been deliberately selected.',
    type: 'checkbox',
    name: 'confirm_default_tip',
  },
  {
    title: 'QR Tender Behavior',
    description:
      "This setting determines if the POS should show a QR code that the guest scans through their Wallet, or if the POS should scan the QR code generated from the user's Wallet.",
    type: 'select',
    name: 'qr_tender',
    options: [
      {
        uuid: '#default_empty_value',
        name: 'Default',
      },
      {
        uuid: 'pos_shows_qr',
        name: 'POS Shows QR',
      },
      {
        uuid: 'pos_scans_qr',
        name: 'POS Scans QR',
      },
    ],
  },

  {
    title: 'Enable POS Email Receipts',
    description:
      'When this setting is enabled, an Email Receipt button will appear on the POS receipt screens.',
    type: 'checkbox',
    name: 'enable_pos_email_receipts',
  },
  {
    title: 'Enable POS SMS Receipts',
    description:
      'When this setting is enabled, an SMS Receipt button will appear on the POS receipt screens.',
    type: 'checkbox',
    name: 'enable_pos_sms_receipts',
    action: 'handleSetEnablePosSmsReceiptsValidation',
  },
  {
    title: 'SMS Receipt Message',
    description:
      'This setting determines the receipt message sent via SMS to guests when the "Enable SMS Receipts" setting above is enabled. \n #{receipt_uri} must be included in the message to display the order URL. \n #{order_number} may be included in the message to display the order number. \n#{location_name} may be included in the message to display the location name.',
    type: 'textarea',
    name: 'sms_receipt_message',
  },
  {
    title: 'Custom Tip Configuration',
    description:
      'This setting determines the default custom tip options across the venue. Any custom tip options set at the revenue center level overrides this setting for that particular revenue center.',
    type: 'button',
    label: 'Configure',
    action: 'handleClickCustomTipConfiguration',
  },
]

export const VENUE_SETTINGS_FIELDS_REQUIRED_CONFIRMATION = [
  'force_offline_mode',
]

export const STANDS_PAYMENT_TENDER_SETTINGS = [
  {
    title: 'Enable Cash Tender',
    name: 'allow_cash_payments_on_pos',
  },
  {
    title: 'Enable Ticket Tender',
    name: 'allow_ticket_payments_on_pos',
  },
  {
    title: 'Enable Gift Card Tender',
    name: 'allow_gift_card_payments_on_pos',
  },
  {
    title: 'Enable Tips',
    name: 'provide_tip_suggestions',
  },
]

export const TIP_CONFIGURATIONS_SETTINGS = [
  {
    name: 'tip_should_include_charges',
    title: 'Include Charges & Fees',
    description:
      'When activated, tips will be calculated based on the total including service charges and delivery fees.',
  },
  {
    name: 'tip_should_include_promotions',
    title: 'Include Promotions',
    description:
      'When activated, tips will be calculated based on the total after applying promotions.',
  },
  {
    name: 'custom_tip_option',
    title: 'Enable Custom Tip Option',
    description:
      'When activated, guests can enter a custom tip amount and will replace tip option five below.',
  },
]

export const TIP_OPTIONS_SETTINGS_NAMES = [
  'tip_values',
  'selected_tip_option',
]

export const HIDEABLE_REVENUE_CENTERS_SECTIONS = [
  'Tip Configurations',
]

// filter options: Selected, All (default)
// component: CategoryItems, ModifierGroupAssignedItems
// route: /categories/:uuid,
export const itemsCategoryFilterOptions = [
  {
    label: 'All Items',
    uuid: 'all',
  },
  {
    label: 'Selected Items',
    uuid: 'selected',
  },
]

export const displayCategoriesFilterOption = [
  {
    label: 'All Display Categories',
    uuid: 'all',
  },
  {
    label: 'Selected Categories',
    uuid: 'selected',
  },
]

export const revenueCentersFilterOptions = [
  {
    label: 'All Revenue Centers',
    uuid: 'all',
  },
  {
    label: 'Selected Revenue Centers',
    uuid: 'selected',
  },
]

// filter options: Selected, All (default)
// component: ModifierDrawer
export const MODIFIER_FILTER_OPTIONS = [
  { label: 'All Modifier Groups', uuid: 'all' },
  {
    label: 'Selected Modifier Groups',
    uuid: 'selected',
  },
]

// filter options: Selected, All (default)
// component: ReportingCategoriesDrawer
export const REPORTING_CATEGORIES_FILTER_OPTIONS = [
  { label: 'All Reporting Categories', uuid: 'all' },
  {
    label: 'Selected Categories',
    uuid: 'selected',
  },
]

export const MENUS_DRAWER_DOUBLE_TOGGLE_BUTTON_OPTIONS = [
  { label: 'All Menus', uuid: 'All Menus' },
  { label: 'Selected Menus', uuid: 'Selected Menus' },
]

// component: SelectableItemLabel
export const itemInventoryStates = new Map([
  ['available', 'available'],
  ['low_on_inventory', 'low-on-inventory'],
  ['unavailable', 'unavailable'],
])

export const CATEGORY_BANNER_SETTINGS = {
  text: 'The sorting feature in Menu Manager has not been enabled for your organization. Please contact your account manager to enable this feature.',
  linkText: 'Learn More',
}

export const MAX_SELECT_HEIGHT = 400

export const MENU_MODEL_DESCRIPTIONS = {
  newMenu:
    'Menu Models provide pre-set service models, simplifying setup by removing extra configuration step.',
  emptyConfigurationId:
    'Menu Models provide pre-set service models, simplifying setup by removing extra configuration steps. Upgrade your menu by selecting a Menu Model below.',
  filledConfigurationId:
    'Menu Models provide pre-set service models, simplifying setup by removing extra configuration steps. You may change this menu to use a different Menu Model below.',
}

export const SETTINGS_LEVELS = {
  standMenuId: 'MENU',
  standId: 'STAND',
  venueUuid: 'VENUE',
  organizationName: 'ORGANIZATION',
}

export const SETTINGS_LEVELS_ORDER = {
  MENU: 0,
  STAND: 1,
  VENUE: 2,
  ORGANIZATION: 3,
}

export const POS_ACCOUNTS_STATUSES = [
  {
    uuid: 'active',
    name: 'Active',
  },
  {
    uuid: 'inactive',
    name: 'Inactive',
  },
]

export const POS_ACCOUNTS_ROLES = [
  {
    uuid: 'manager',
    name: 'Manager',
  },
  {
    uuid: 'cashier',
    name: 'Cashier',
  },
]

export const CONVERT_TO_ORGANIZATION_ATTENDANT_MESSAGES = [
  'This POS account is assigned exclusively to a specific venue within your organization and cannot be used to log into a POS in other venues within your organization.',
  'If there are multiple POS accounts created for this specific user, please deactivate them once you have converted this POS account.',
  "To modify this POS account and allow their usage throughout the entire organization, please click the button below. This change is irreversible but required to edit this POS account's data.",
]
